import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UspCard } from '@features/product/product.models';
import { getUspCard } from '@features/product/helper/get-usp-cards-by-page-id';

@Pipe({
    name: 'getUspCard',
    standalone: true
})
export class GetUspCardPipe implements PipeTransform {
    constructor(private settingsService: SettingsService) {}

    // yes, mapping to a custom type, but that is because of the image is not compatible with the UmbracoImage type
    // on the app-image component, and this will make it compatible
    transform(pageId?: string): Observable<UspCard[] | undefined> {
        if (!pageId) {
            return of(undefined);
        }

        return this.settingsService.settings$.pipe(map(({ uspCardSettings }) => getUspCard(uspCardSettings, pageId)));
    }
}
